/* eslint-disable import/no-extraneous-dependencies */
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { useMemo, useState } from "react";

export default function KendoMultiselect(props) {
  const [currentFilter, setCurrentFilter] = useState("");
  const filteredData = useMemo(() => {
    if (currentFilter) {
      return filterBy(props.data.slice(), currentFilter);
    }
    return props.data;
  }, [currentFilter, props.data]);
  return (
    <MultiSelect
      {...props}
      filterable={props?.filterable !== false}
      data={filteredData}
      onFilterChange={(e) => {
        setCurrentFilter(e.filter);
      }}
    />
  );
}
